import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { isFragment } from 'react-is';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import PageBreadcrumbsItemHistory from '../PageBreadcrumbsItemHistory';
import PageBreadcrumbsItemHome from '../PageBreadcrumbsItemHome';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    }
  };
});

var _ref2 = React.createElement(PageBreadcrumbsItemHistory, null);

function PageBreadcrumbs(_ref) {
  var pChildren = _ref.children,
      className = _ref.className,
      disableHistory = _ref.disableHistory,
      disableHome = _ref.disableHome,
      homeBreadcrumbProps = _ref.homeBreadcrumbProps,
      rest = _objectWithoutProperties(_ref, ["children", "className", "disableHistory", "disableHome", "homeBreadcrumbProps"]);

  var classes = useStyles({}, {
    name: 'SxPageBreadcrumbs'
  });
  var children = React.useMemo(function () {
    return isFragment(pChildren) ? pChildren.props.children : pChildren;
  }, [pChildren]);
  return React.createElement(Breadcrumbs, _extends({
    "aria-label": "Page Breadcrumbs"
  }, rest, {
    className: clsx(classes.root, className)
  }), !disableHistory && _ref2, !disableHome && React.createElement(PageBreadcrumbsItemHome, homeBreadcrumbProps), children);
}

PageBreadcrumbs.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disableHistory: PropTypes.bool,
  disableHome: PropTypes.bool,
  homeBreadcrumbProps: PropTypes.shape({})
};
PageBreadcrumbs.defaultProps = {
  children: null,
  className: undefined,
  disableHistory: false,
  disableHome: false,
  homeBreadcrumbProps: {}
};
export default PageBreadcrumbs;